// Standard alert system for the application
export default {
  install(app) {
    const alerts = {
      success(message, options = {}) {
        this.show({
          type: 'success',
          message,
          color: 'success',
          icon: 'mdi-check-circle',
          ...options
        })
      },

      error(message, options = {}) {
        this.show({
          type: 'error',
          message,
          color: 'error',
          icon: 'mdi-alert-circle',
          ...options
        })
      },

      warning(message, options = {}) {
        this.show({
          type: 'warning',
          message,
          color: 'warning',
          icon: 'mdi-alert',
          ...options
        })
      },

      info(message, options = {}) {
        this.show({
          type: 'info',
          message,
          color: 'info',
          icon: 'mdi-information',
          ...options
        })
      },

      show(alert) {
        // Dispatch to Vuex store
        app.config.globalProperties.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          timeout: 3000,
          closable: true,
          ...alert
        })
      }
    }

    // Make alerts available globally
    app.config.globalProperties.$alerts = alerts
    app.provide('alerts', alerts)
  }
} 